<template>
  <form id="freeTextSearch" class="ui form" @submit.prevent="search()">
    <div class="ui icon input">
      <input type="text" v-model="model.q" placeholder="お店を検索">
      <i class="search icon"></i>
    </div>
  </form>
</template>

<script>
export default {
    data: function() {
        return {
            model: {},
        };
    },
    methods: {
        search: function() {
            var query = [];
            if (this.model.q) {
                query.push('q=' + encodeURIComponent(this.model.q))
            }
            //hotelplus用条件分岐
            if (location.pathname === '/hotel/'){
                query.push('shop_types=4')
            }
            window.location.href = '/shops/search?' + _.join(query, '&');
        }
    }
};
</script>